import Api from '@/services/API';


/**
 * @typedef {ResetPassword}
 */

export default class ResetPassword extends Api {
  /**
   * @type {String}
   */
  static base = process.env.VUE_APP_API_HOST

  /**
   * @type {String}
   */
  static resource = '/member/password-recovery'

  /**
   * @param {String} resource
   * @param {Object} options
   * @param {Object} http
   */
  constructor(resource, options = {}, http = null) {
    super(ResetPassword.normalize(ResetPassword.base, resource), options, http);
  }

  /**
   * @return {this}
   */
  static build() {
    return new this(this.resource);
  }

  reset(email, captcha) {
    let data = {
      email: email,
      captcha: captcha,
    }

    return this.post('', data);
  }
}